/* ============================================================
   KartenKoloss - "Haeufig zusammen gekauft"
   assets/kk-complementary.js
   ------------------------------------------------------------
   Klappt die Liste ab dem 4. Artikel ein und blendet leere
   Zeilen (ausverkaufte Artikel) aus. Reine Verbesserung:
   ohne JS bleibt alles sichtbar und bedienbar.
   Der Warenkorb-Drawer nutzt kein <li>-Layout und wird
   bewusst uebersprungen.
   ============================================================ */

(function(){
  var VISIBLE = 3;
  var CHEV = '<svg class="kk-fbt__chev" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';

  function init(root){
    if (root.getAttribute('data-kk-fbt')) return;
    root.setAttribute('data-kk-fbt','1');

    var all = root.querySelectorAll('li.t4s-complimentary_product');
    /* Kein li-Layout (z.B. Warenkorb-Drawer) -> nichts zu tun */
    if (!all.length) return;
    var items = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('.kk-fbt__row')) items.push(all[i]);
      else all[i].style.display = 'none';
    }
    /* Nichts Lieferbares dabei -> Block gar nicht zeigen */
    if (!items.length) { root.style.display = 'none'; return; }

    items[0].classList.add('kk-fbt-first');
    if (items.length <= VISIBLE) return;

    for (var j = VISIBLE; j < items.length; j++) items[j].classList.add('kk-fbt-extra');
    root.classList.add('is-collapsed');

    var rest = items.length - VISIBLE;
    var more = rest + ' weitere anzeigen';
    var less = 'Weniger anzeigen';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kk-fbt__more';
    btn.setAttribute('aria-expanded','false');
    btn.innerHTML = '<span class="kk-fbt__more-lbl"></span>' + CHEV;
    var lbl = btn.querySelector('.kk-fbt__more-lbl');
    lbl.textContent = more;

    btn.addEventListener('click', function(){
      var open = !root.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      lbl.textContent = open ? less : more;
    });
    root.appendChild(btn);
  }

  function boot(){
    var nodes = document.querySelectorAll('.t4s-complimentary');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
